import React, { useState } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Outlet,
  Navigate,
  useLocation,
} from "react-router-dom";

// --- НИЙТИЙН ХУУДСУУД ---
import Login from "./screens/loginScreen/loginScreen";
import LoginAdmin from "./screens/loginAdmin/loginAdminScreen";
import Signup from "./screens/signUpScreen/signUp";
import Parking from "./screens/parkingScreen/parking";
import PlateScreen from "./screens/plateScreen/plateScreen";
import InviteScreen from "./screens/inviteScreen/inviteScreen";
import BuildingDetail from "./screens/building/detail";
import PrivacyPolicy from "./PrivacyPolicy/PrivacyPolicy";
import SupportPage from "./screens/supportPage/supportPage";
import EbarimtScreen from "./screens/ebarimtScreen/ebarimt";
import IParkingLanding from "./web/web";

// --- DASHBOARD ХУУДСУУД ---
import Dashboard from "./screens/dashboard/dashboard";
import PaymentDashboard from "./screens/dashboard/paymentDashboard";
import Settings from "./screens/settings/settings";
import Report from "./screens/reportScreen/report";
import Blocked from "./screens/settings/blocked";
import Building from "./screens/building/building";
import Garage from "./screens/garageScreen/garage";
import GrageRegister from "./screens/garageRegiterScreen/garageRegister";
import AppScreen from "./screens/appScreen/appScreen";

// --- ADMIN ХУУДСУУД ---
import PermissionCompany from "./screens/permissionManager/PermissionCompany";
import CreateParking from "./screens/createParking/createParking";

// --- ХҮНИЙ НӨӨЦ ---
import HrDashboard from "./humanResource/dashboard/humanDashboard";
import RegisterEmployee from "./humanResource/registerEmplyee/registerEmployee";
import Controller from "./humanResource/controller/controller";
import TimeBalance from "./humanResource/timeBalance/TimeBalance";
import RequestManager from "./humanResource/reguest/RequestManager";

// --- АЖИЛТНЫ ХУУДСУУД ---
import MyProfile from "./employee/profile/profile";
import MyAttendance from "./employee/attendance/attendance";
import MyRequests from "./employee/empRequiest/empRequiest";
import MySettings from "./employee/empSettings/empSettings";

// --- ҮНДСЭН КОМПОНЕНТУУД ---
import PrivateRoute from "./component/privateRoot";
import { AuthProvider, useAuth } from "./component/AuthProvider";
import DashboardLayout from "./screens/dashboard/layout";

function normalizeRole(value) {
  return String(value || "").trim().toLowerCase();
}

/**
 * /createParking:
 *  - Зөвхөн AuthProvider-ийн нэгдсэн user/role/profile ашиглана.
 *  - Эхний auth loading үед login руу үсрэхгүй.
 *  - masterOnly (legacy guard)-ээс үл хамааран яг superadmin-ыг шалгана.
 *  - Эрх тодорхойгүй, алдаатай, эсвэл идэвхгүй бол fail closed.
 */
function SuperAdminRoute({ children }) {
  const { user, loading, role, isActive, error, profileMissing } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <main className="tw-flex tw-min-h-screen tw-items-center tw-justify-center tw-bg-slate-50">
        <p className="tw-text-sm tw-font-medium tw-text-slate-600">Super Admin эрх шалгаж байна...</p>
      </main>
    );
  }

  if (!user) {
    return (
      <Navigate
        to="/login/createParking"
        replace
        state={{ from: location.pathname }}
      />
    );
  }

  const validSuperAdmin =
    !error && !profileMissing && isActive === true &&
    normalizeRole(role) === "superadmin";

  if (!validSuperAdmin) {
    const message = error
      ? "Хэрэглэгчийн эрхийн мэдээлэл уншигдсангүй. Сүлжээ болон Firestore Rules-ийг шалгана уу."
      : profileMissing
        ? "users/{uid} замд хэрэглэгчийн profile олдсонгүй."
        : isActive !== true
          ? "Хэрэглэгчийн эрх идэвхгүй эсвэл төлөв нь баталгаажаагүй байна."
          : "Зөвхөн superadmin эрхтэй хэрэглэгч энэ хуудсанд нэвтэрнэ.";

    return (
      <main className="tw-flex tw-min-h-screen tw-items-center tw-justify-center tw-bg-slate-50 tw-p-5">
        <section className="tw-w-full tw-max-w-md tw-rounded-2xl tw-border tw-border-slate-200 tw-bg-white tw-p-8 tw-text-center tw-shadow-sm">
          <h1 className="tw-text-lg tw-font-bold tw-text-slate-900">Нэвтрэх эрх хүрэлцэхгүй байна</h1>
          <p className="tw-mt-3 tw-text-sm tw-text-slate-600">{message}</p>
          <a className="tw-mt-5 tw-inline-block tw-rounded-xl tw-bg-blue-600 tw-px-5 tw-py-3 tw-text-sm tw-font-semibold tw-text-white" href="/dashboard">
            Самбар руу буцах
          </a>
        </section>
      </main>
    );
  }

  return children || <Outlet />;
}

// SIDEBAR-ТАЙ ХАМГААЛАГДСАН LAYOUT
const ProtectedLayout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const { role, permissions } = useAuth();

  const toggleSidebar = () => {
    setSidebarOpen((previous) => !previous);
  };

  return (
    <DashboardLayout
      sidebarOpen={sidebarOpen}
      toggleSidebar={toggleSidebar}
      userRole={role || "operator"}
      allowedMenus={permissions || []}
    >
      <Outlet />
    </DashboardLayout>
  );
};

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          {/* PUBLIC — SIDEBAR-ГҮЙ */}
          <Route path="/" element={<Login />} />
          <Route path="/login" element={<Login />} />
          <Route path="/login/createParking" element={<LoginAdmin />} />
          <Route path="/parking/:id" element={<Parking />} />
          <Route path="/plate/:parkId" element={<PlateScreen />} />
          <Route path="/detail/:detailId" element={<BuildingDetail />} />
          <Route path="/invite/:parkId" element={<InviteScreen />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/support" element={<SupportPage />} />
          <Route path="/ebarimt" element={<EbarimtScreen />} />
          <Route path="/web" element={<IParkingLanding />} />

          {/* PRIVATE — SIDEBAR-ГҮЙ ADMIN */}
          <Route
            path="/createParking"
            element={
              <SuperAdminRoute>
                <CreateParking />
              </SuperAdminRoute>
            }
          />
          <Route
            path="/signUp"
            element={
              <PrivateRoute masterOnly>
                <Signup />
              </PrivateRoute>
            }
          />
          <Route
            path="/company"
            element={
              <PrivateRoute masterOnly>
                <PermissionCompany />
              </PrivateRoute>
            }
          />

          {/* PRIVATE — SIDEBAR-ТАЙ */}
          <Route
            element={
              <PrivateRoute enforcePermissions>
                <ProtectedLayout />
              </PrivateRoute>
            }
          >
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/paymentDashboard" element={<PaymentDashboard />} />
            <Route path="/hrDashboard" element={<HrDashboard />} />
            <Route path="/registerEmployee" element={<RegisterEmployee />} />
            <Route path="/settings" element={<Settings />} />
            <Route path="/report" element={<Report />} />
            <Route path="/blocked" element={<Blocked />} />
            <Route path="/building" element={<Building />} />
            <Route path="/garage" element={<Garage />} />
            <Route path="/grageRegister" element={<GrageRegister />} />
            <Route path="/app" element={<AppScreen />} />
            <Route path="/controller" element={<Controller />} />
            <Route path="/timeBalance" element={<TimeBalance />} />
            <Route path="/requests" element={<RequestManager />} />
            <Route path="/profile" element={<MyProfile />} />
            <Route path="/attendance" element={<MyAttendance />} />
            <Route path="/requestEmp" element={<MyRequests />} />
            <Route path="/empSettings" element={<MySettings />} />
          </Route>
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
